<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div slot="content" class="dialog-content flex-column-center">
      <div class="no-cv flex-column-center" v-if="pageData.modal_text">
        <p class="no-cv-title" :class="pageData.modal_text.button === '导入简历' ? 'flex-center' : 'flex-between'">
          <span>{{pageData.modal_text && pageData.modal_text.title}}</span>
          <span v-if="pageData.modal_text.button !== '导入简历'" @click="handleClose" class="iconfont iconx"/>
        </p>
        <p class="desc" :class="{'desc-left': pageData.modal_text.button !== '导入简历'}">{{ pageData.modal_text &&
          pageData.modal_text.content }}</p>
        <p v-if="pageData.modal_text && pageData.modal_text.error_msg_text" class="error-msg">{{ pageData.modal_text
          && pageData.modal_text.error_msg_text }}</p>
        <div class="no-cv-footer flex-center" :class="{'only-btn': pageData.modal_text.button !== '导入简历'}"
             v-if="pageData.modal_text">
          <div @click="routeByCreate('create')" class="flex-center" v-if="pageData.modal_text.button === '导入简历'">创建简历</div>
          <div @click="routeByCreate" class="flex-center">{{pageData.modal_text.button}}</div>
        </div>
      </div>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '../../components/global/w-dialog'

	export default {
		props: {
			state: {
				type: Boolean,
				default: false
			},
			pageData: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		name: 'job-alert',
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			routeByCreate (type) {
				if (type === 'create') {
					this.$router.replace('/cvs')
        } else {
					window.location.href = this.pageData.modal_text.button === '导入简历' ? `/welcome/mobile_import_cv_index` : `/cvs`
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  @import "@/assets/scss/global/mixin";
  .dialog-content {
    background-color: $color-light;
    border-radius: 8px;
    width: 90vw;
    .no-cv {
      padding: 30px 40px 0;
      .no-cv-title {
        padding: 0 24px;
        width: 100%;
        color: $color-title;
        font-size: $font-size-large-x;
        font-weight: 600;
        margin-bottom: 24px;
      }
      .desc {
        width: 100%;
        color: $color-dark-gray;
        line-height: 24px;
        text-align: center;
        margin-bottom: 10px;
        padding: 0 24px;
      }
      .desc-left {
        text-align: left;
      }
      .error-msg {
        color: $color-theme;
        padding: 0 24px;
        line-height: 20px;
        width: 100%;
        /*margin-bottom: 32px;*/
      }
      .no-cv-footer {
        width: 90vw;
        border-top: 1px solid #E1E2E6;
        margin-top: 32px;
        div {
          height: 53px;
          flex: 1;
          font-size: $font-size-large;
          color: #323233;
          &:last-child {
            border-left: 1px solid #E1E2E6;
            color: $color-theme
          }
        }
      }
      .only-btn {
        border-top: none;
        padding: 0 24px;
        div {
          color: $color-light !important;
          border: none;
          background-color: $color-theme;
          border-radius: 2px;
          height: 38px;
          margin-bottom: 24px;
        }
      }
    }
  }
</style>
